<template>
	<pageViewContainer>
		<el-row :gutter="10" style="height: 100%;">
			<el-col :span="8">
				<groupTem></groupTem>
			</el-col>
			<el-col :span="16">
				<accountListTem></accountListTem>
			</el-col>
		</el-row>
	</pageViewContainer>
</template>

<script>
	import groupTem from './components/group.vue';
	import accountListTem from './components/accountList.vue';
	export default {
		components: { groupTem, accountListTem }
	}
</script>

<style>
</style>